
import React from 'react'
import { InfoContext } from './context'
import PropTypes from 'prop-types'

export default function InfoConsumer({ children }) {
    return (
        <InfoContext.Consumer>
            {children}
        </InfoContext.Consumer>
    )
}
InfoConsumer.propTypes = {
    children: PropTypes.func
}